export default __webpack_public_path__ + "static/media/hassan4.70a7bd9b.JPG";